export default __webpack_public_path__ + "static/media/AnovaUI-Italic.09530cf9.woff2";